import { Box, Typography } from '@mui/material';
import React from 'react';

export const MatchingPropFieldTextShow = ({ property }) => {
  const { label, publicLabel, value, type } = property;

  return (
    <Box className="flex items-start justify-start gap-2">
      <Typography fontWeight={600}>{`${publicLabel || label}: `}</Typography>
      <Typography>{`${value || '-'}`}</Typography>
    </Box>
  );
};
